import { useModuleBEM } from "@b2bportal/core-themes";
import { useCheckoutStateSelector } from "@checkout/index";
import { useI18nContext } from "@hopper-b2b/i18n";
import { getRbcLodgingPriceBreakdown } from "../PayAtProperty/getRbcLodgingPriceBreakdown";
import { PriceLine } from "../TotalAmountLines/TotalAmountLines";
import styles from "./DueAtPropertyTotal.module.scss";

export const DueAtPropertyTotal = ({
  fiatFormatOptions,
}: {
  fiatFormatOptions?: Intl.NumberFormatOptions;
}) => {
  const { t, formatFiatCurrency } = useI18nContext();
  const [block, cn] = useModuleBEM(styles, "DueAtPropertyTotal");

  const breakdown = useCheckoutStateSelector(getRbcLodgingPriceBreakdown);
  const total = breakdown?.taxesAndFeesDueAtProperty?.total;

  if (total == null) {
    return null;
  }

  const valueFiat = total.value.fiat;
  const originalFiat = total.valueInOriginalCurrency.fiat;
  const showDisclaimer = originalFiat.currencyCode !== valueFiat.currencyCode;

  return (
    <div className={block}>
      <PriceLine
        value={formatFiatCurrency(valueFiat, fiatFormatOptions)}
        label={t("lodgingPriceBreakdown.dueAtProperty")}
        type="due-at-property"
      />
      {showDisclaimer && (
        <div className={cn("disclaimer")}>
          {t("apac.priceBreakdown.payLaterFeesDisclaimer", {
            amount: formatFiatCurrency(originalFiat, fiatFormatOptions),
          })}
        </div>
      )}
    </div>
  );
};
